import { Card } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { ChangeDatePersian } from "@/util/tools";
import NoData from "@/util/view/NoData";
import dynamic from "next/dynamic";
import { useMemo } from "react";
import { CommentsType } from "../product";

const AddComment = dynamic(() => import("./AddComment"), { ssr: false });

interface CommentListProps {
    prodId: number;
    token: any;
    data: CommentsType;
}

const CommentList = ({ prodId, token, data }: CommentListProps) => {
    const hasComments = useMemo(() => data.data.rows.length > 0, [data]);

    return (
        <div className="flex flex-wrap">
            <div className="md:w-[70%] w-full p-1">
                {!hasComments ? (
                    <NoData />
                ) : (
                    data.data.rows.map((i) => (
                        <Card key={i.id} className="m-2 dark:bg-slate-600">
                            <div className="flex p-2 justify-between">
                                <p>{i.comment_first_name + " " + i.comment_last_name}</p>
                                <p>{ChangeDatePersian(i.createdAt)}</p>
                            </div>
                            <Separator />
                            <div className="p-2">
                                {i.comment_description}
                            </div>
                            {i?.childComments?.map((b) => (
                                <Card key={b.id} className="m-2 dark:bg-slate-600">
                                    <div className="flex p-2 justify-between">
                                        <p>{b.comment_first_name + " " + b.comment_last_name}</p>
                                        <p>{ChangeDatePersian(b.createdAt)}</p>
                                        <p className={`${b.comment_status === 1 ? "bg-lime-800" : "bg-red-700"} rounded px-2 text-gray-100`}>
                                            {b.comment_status === 1 ? "تایید شده" : "تایید نشده"}
                                        </p>
                                    </div>
                                    <Separator />
                                    <div className="p-2">
                                        {b.comment_description}
                                    </div>
                                </Card>
                            ))}
                        </Card>
                    ))
                )}
            </div>
            <div className="md:w-[30%] w-full p-1">
                <AddComment token={token} prodId={prodId} />
            </div>
        </div>
    );
};

export default CommentList;
